export default {
  fields: {
    caterer_id: {
      readOnly: true,
    },
    deletable: {
      type: 'boolean',
      readOnly: true
    },
    reasons_not_deletable: {
      type: 'object',
      readOnly: true
    },    
    created_at: {
      type: 'date',
      readOnly: true,
    },
    updated_at: {
      type: 'date',
      readOnly: true,
    },
  },
  relationships: {
    caterer: 'caterers'
  }
}
